import $ from 'jquery'
import TomSelect from 'tom-select'
import 'tom-select/dist/css/tom-select.bootstrap5.css'

function initTomSelect() {
  document.querySelectorAll('.tom-select').forEach((el) => {
    if (el.tomselect) return
    new TomSelect(el, {
      plugins: el.multiple ? ['remove_button'] : [],
      placeholder: el.dataset.placeholder || 'Select',
      allowEmptyOption: true,
    })
  })
}

export default function() {
  initTomSelect()
  $(document).on('cocoon:after-insert', () => {
    initTomSelect()
  })
}
